function EditIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M11.5 2.5a1.4 1.4 0 0 1 2 2L5.8 12.2l-2.7.7.7-2.7 7.7-7.7Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function DeleteIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M3 4.5h10M6.5 4.5V3.5h3v1M5 4.5v8h6v-8"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function AdminIconButton({ label, variant = 'default', onClick, disabled }) {
  return (
    <button
      type="button"
      className={`admin-icon-btn${variant === 'danger' ? ' admin-icon-btn--danger' : ''}`}
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      title={label}
    >
      {variant === 'danger' ? <DeleteIcon /> : <EditIcon />}
    </button>
  );
}

export default AdminIconButton;
